import { createAction, props } from '@ngrx/store';
import { BoelsCatalogsResponse } from '@boels/models';

export const LOAD_CATALOGS = '[Catalogs] Load Catalogs';
export const LOAD_CATALOGS_SUCCESS = '[Catalogs] Load Catalogs Success';
export const LOAD_CATALOGS_FAIL = '[Catalogs] Load Catalogs Fail';
export const GET_CATALOGS = '[Catalogs] Get Catalogs';
export const GET_CATALOGS_FOR_ACTIVE_BASESITE_AND_CULTURE =
  '[Catalogs] Get Catalogs For Active BaseSite and Culture';

export const loadCatalogs = createAction(
  LOAD_CATALOGS,
  props<{
    baseSite?: string;
    culture?: string;
  }>(),
);

export const getCatalogsForActiveBaseSiteAndCulture = createAction(
  GET_CATALOGS_FOR_ACTIVE_BASESITE_AND_CULTURE,
);
export const getCatalogs = createAction(
  GET_CATALOGS,
  props<{
    baseSite: string;
    culture: string;
  }>(),
);

export const loadCatalogsSuccess = createAction(
  LOAD_CATALOGS_SUCCESS,
  props<{
    catalogs: BoelsCatalogsResponse;
    culture: string;
  }>(),
);

export const loadCatalogsFail = createAction(
  LOAD_CATALOGS_FAIL,
  props<{ errorMessage: string }>(),
);
